import { Directive, Input, ElementRef, Renderer2, OnDestroy, OnInit } from '@angular/core';
import { PatientService } from '../../core/services/patient.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[appPatientActive]'
})
export class PatientActiveDirective implements OnInit, OnDestroy {
    @Input('appPatientActive') patientId: string | undefined;
    private sub: Subscription | undefined;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private patientService: PatientService
    ) { }

    ngOnInit() {
        this.sub = this.patientService.currentPatient$.subscribe((currentPatient: any) => {
            const currentId = currentPatient?.id;
            if (this.patientId && currentId && this.patientId === currentId) {
                this.renderer.addClass(this.el.nativeElement, 'active');
            } else {
                this.renderer.removeClass(this.el.nativeElement, 'active');
            }
        });
    }

    ngOnDestroy() {
        this.sub?.unsubscribe();
    }
} 